module.exports = __webpack_public_path__ + "img/five5Red.5f7bf0e8.jpg";